/*
 *                     NOTICE
 *            COPYRIGHT 2022 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

/**
 * Enum whose numeric value is 0=Sunday, ... 6=Saturday, which is  also aligned with the
 * javascript Date.getDay() method that returns a number with the same semantics (and Ab Initio uses the same
 * DayOfWeek semantics).
 */
export let DayOfWeek = /*#__PURE__*/function (DayOfWeek) {
  // Aligned with Date.getDay(): number = 0 for Sunday, ... 6 for Saturday
  DayOfWeek[DayOfWeek["SUN"] = 0] = "SUN";
  DayOfWeek[DayOfWeek["MON"] = 1] = "MON";
  DayOfWeek[DayOfWeek["TUE"] = 2] = "TUE";
  DayOfWeek[DayOfWeek["WED"] = 3] = "WED";
  DayOfWeek[DayOfWeek["THU"] = 4] = "THU";
  DayOfWeek[DayOfWeek["FRI"] = 5] = "FRI";
  DayOfWeek[DayOfWeek["SAT"] = 6] = "SAT";
  return DayOfWeek;
}({});
//# sourceMappingURL=DayOfWeek.js.map
